module.exports = __webpack_public_path__ + "static/media/tiet-kiem-nang-luong.995c5101.svg";